import React from "react";
import getYear from "date-fns/getYear";
import getMonth from 'date-fns/getMonth';
import YearDropdown from "./YearDropdown";
import MonthDropdown from "./MonthDropdown";
import { CalHeader, MonthYearHeader } from "./SubComponents";
import iconTypes from "../../../AlmeUtilities/Icons/IconTypes";
import NavigationButton from "./NavigationButton";
function getMinYear() {
    return getYear(new Date()) - 100;
}
function getMaxYear() {
    return getYear(new Date()) + 100;
}
const CalendarHeader = ({ date, minDate, maxDate, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled, }) => {
    const minYear = minDate ? getYear(minDate) : getMinYear();
    const maxYear = maxDate ? getYear(maxDate) : getMaxYear();
    return (React.createElement(CalHeader, null,
        React.createElement(NavigationButton, { onClick: decreaseMonth, disabled: prevMonthButtonDisabled, icon: iconTypes.ChevronLeft, label: "Previous month" }),
        React.createElement(MonthYearHeader, null,
            React.createElement(MonthDropdown, { currentMonth: getMonth(date), changeMonth: changeMonth }),
            React.createElement(YearDropdown, { currentYear: getYear(date), minYear: minYear, maxYear: maxYear, changeYear: changeYear })),
        React.createElement(NavigationButton, { onClick: increaseMonth, disabled: nextMonthButtonDisabled, icon: iconTypes.ChevronRight, label: "Next month" })));
};
export default CalendarHeader;
